import {Injectable} from "@angular/core";
import {ChatInfo, MessageWrapper, RoomId} from "../models/chat";

@Injectable({
    providedIn: 'root'
})
export class EffectsService {
    private events = new Array<Effects>()
    private listener?: EffectListener

    broadcast(effect: Effects) {
        if (this.listener) {
            this.listener(effect)
        } else {
            this.events.push(effect)
        }
    }

    subscribe(listener: EffectListener) {
        this.listener = listener

        if (this.events.length > 0) {
            this.events.forEach((value) => {
                this.listener(value)
            })
            this.clear()
        }
    }

    unsubscribe() {
        this.listener = null
    }

    clear() {
        this.events.length = 0
    }
}

type EffectListener = (effect: Effects) => void

export const CHATS_RECEIVED_EFFECT = "CHAT_RECEIVED_EFFECT"
export const ACCOUNT_WILL_DELETE_WARNING = "ACCOUNT_WILL_DELETE_WARNING"
export const ANNOUNCEMENT_EFFECT = "ANNOUNCEMENT_EFFECT"
export const NEW_ROOM_CREATED_EFFECT = "NEW_ROOM_CREATED_EFFECT"
export const SERVER_ROOM_CLOSED_EFFECT = "SERVER_ROOM_CLOSED_EFFECT"
export const NEW_MESSAGE_IN_ROOM_EFFECT = "NEW_MESSAGE_IN_ROOM_EFFECT"
export const SNACK_BAR_MESSAGE_EFFECT = "SNACK_BAR_MESSAGE_EFFECT"
export const WARNING_MESSAGE_EFFECT = "WARNING_MESSAGE_EFFECT"
export const SOCKET_DISCONNECTED_EFFECT = "SOCKET_DISCONNECTED_EFFECT"
export const UNPAID_ROOM_EFFECT = "UNPAID_ROOM_EFFECT"
export const LOW_BALANCE_UPCOMING_CHARGE_EFFECT = "LOW_BALANCE_UPCOMING_CHARGE_EFFECT"
export const RECONNECTING_EFFECT = "RECONNECTING_EFFECT"
export const PREMIUM_UPSELL_EFFECT = "PREMIUM_UPSELL_EFFECT"

export class ChatsReceivedEffect {
    public readonly type = CHATS_RECEIVED_EFFECT;

    constructor() {
    }
}

export class AccountWillDeleteWarning {
    public readonly type = ACCOUNT_WILL_DELETE_WARNING;

    constructor(readonly willDeleteVia: number) {
    }
}

export class AnnouncementEffect {
    public readonly type = ANNOUNCEMENT_EFFECT;

    constructor(readonly title: string, readonly html: string) {
    }
}

export class NewRoomCreatedEffect {
    public readonly type = NEW_ROOM_CREATED_EFFECT;

    constructor(public chat: ChatInfo, public createdBy: string) {
    }
}

export class ServerRoomClosedEffect {
    public readonly type = SERVER_ROOM_CLOSED_EFFECT;

    constructor(public room: string) {
    }
}

export class NewMessageInRoomEffect {
    public readonly type = NEW_MESSAGE_IN_ROOM_EFFECT;

    constructor(public room: string, public roomId: RoomId, public message: MessageWrapper) {
    }
}

export class SnackBarMessageEffect {
    public readonly type = SNACK_BAR_MESSAGE_EFFECT;

    constructor(public readonly message: string, public readonly action: string, public readonly duration: number) {
    }
}

export class WarningMessageEffect {
    public readonly type = WARNING_MESSAGE_EFFECT;

    constructor(public readonly message: string) {
    }
}

export class SocketDisconnectedError {
    public readonly type = SOCKET_DISCONNECTED_EFFECT;

    constructor(public readonly statusCode: number) {
    }
}

export class UnpaidRoomEffect {
    public readonly type = UNPAID_ROOM_EFFECT;

    constructor(public readonly roomTitle: string) {
    }
}

export class LowBalanceUpcomingChargeEffect {
    public readonly type = LOW_BALANCE_UPCOMING_CHARGE_EFFECT;

    constructor(public readonly roomTitle: string, public readonly daysLeft: number) {
    }
}

export class ReconnectingEffect {
    public readonly type = RECONNECTING_EFFECT;
}

export class PremiumUpsellEffect {
    public readonly type = PREMIUM_UPSELL_EFFECT;
}

export type Effects = ChatsReceivedEffect |
    NewRoomCreatedEffect |
    AnnouncementEffect |
    ServerRoomClosedEffect |
    AccountWillDeleteWarning |
    NewMessageInRoomEffect |
    SnackBarMessageEffect |
    WarningMessageEffect |
    SocketDisconnectedError |
    UnpaidRoomEffect |
    LowBalanceUpcomingChargeEffect |
    ReconnectingEffect |
    PremiumUpsellEffect;